import { useCallback, useRef, useState } from "react";
import CallStartOverlay from "./CallStartOverlay";
import { callDebugLog } from "./callDebug";

/**
 * Instant feedback while startCall / isBlocked run. Does not change CF logic.
 */
export function useCallStartOverlay() {
  const [visible, setVisible] = useState(false);
  const busyRef = useRef(false);
  const tappedAtRef = useRef(0);

  const begin = useCallback(() => {
    if (busyRef.current) return false;
    busyRef.current = true;
    tappedAtRef.current = Date.now();
    setVisible(true);
    callDebugLog("[callStart] tapped", { at: tappedAtRef.current });
    return true;
  }, []);

  const clear = useCallback(() => {
    busyRef.current = false;
    setVisible(false);
  }, []);

  const logReturned = useCallback((callId, meta = {}) => {
    callDebugLog("[callStart] startCall returned", {
      callId,
      ms: Date.now() - tappedAtRef.current,
      ...meta,
    });
  }, []);

  const logFailed = useCallback((error, meta = {}) => {
    console.error("[callStart] failed", {
      error: typeof error === "string" ? error : error?.message || error,
      ms: Date.now() - tappedAtRef.current,
      ...meta,
    });
    clear();
  }, [clear]);

  const overlay = visible ? <CallStartOverlay /> : null;

  return {
    begin,
    clear,
    logReturned,
    logFailed,
    starting: visible,
    overlay,
  };
}
